/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `SpinnerType*`'s.
 */
export type SpinnerType = SpinnerTypeLarge | SpinnerTypeRegular | SpinnerTypeSmall | SpinnerTypeExtraSmall;

/**
 * The Spinner large type.
 */
export type SpinnerTypeLarge = typeof SPINNER_TYPE_LARGE;

/**
 * The Spinner regular type.
 */
export type SpinnerTypeRegular = typeof SPINNER_TYPE_REGULAR;

/**
 * The Spinner small type.
 */
export type SpinnerTypeSmall = typeof SPINNER_TYPE_SMALL;

/**
 * The Spinner extra small type.
 */
export type SpinnerTypeExtraSmall = typeof SPINNER_TYPE_EXTRA_SMALL;

/**
 * The Spinner large constant.
 */
export const SPINNER_TYPE_LARGE = `lg`;

/**
 * The Spinner regular constant.
 */
export const SPINNER_TYPE_REGULAR = `regular`;

/**
 * The Spinner small constant.
 */
export const SPINNER_TYPE_SMALL = `sm`;

/**
 * The Spinner extra small constant.
 */
export const SPINNER_TYPE_EXTRA_SMALL = `xs`;
